/** Which messenger the registrant is reachable on (contact-number companion). */
export type MessengerApp = 'whatsapp' | 'telegram' | 'both';

export type EventRegistrationStatus = 'confirmed' | 'waitlisted' | 'cancelled';
export const EVENT_REGISTRATION_STATUSES: EventRegistrationStatus[] = ['confirmed', 'waitlisted', 'cancelled'];

/** Manual-payment review state (does NOT affect the seat). */
export type EventPaymentStatus = 'pending' | 'verified' | 'rejected';
export const EVENT_PAYMENT_STATUSES: EventPaymentStatus[] = ['pending', 'verified', 'rejected'];

/**
 * A public registration for a meditation event (mirrors the API `EventRegistration`).
 * Only `status` + `adminNote` are admin-editable; the rest is the read-only form
 * submission. Only `confirmed` holds a seat against the event's capacity.
 */
export default interface EventRegistration {
    id: string;
    eventId: string;
    eventSlug: string;
    eventTitle: string;
    eventStartsAt: string;
    fullName: string;
    email: string;
    phone: string;
    messengerApp: MessengerApp;
    age: number;
    healthConditions: string;
    education?: string;
    profession?: string;
    instagram?: string;
    referralMethod: string;
    referrerName?: string;
    filmingConsent: boolean;
    /** Whether the attendee will bring their own mat / headphones. */
    hasMat: boolean;
    hasHeadphones: boolean;
    locale?: string;
    // ── Payment (manual bank transfer) ──
    /** Amount to transfer in Toman, after any promo discount (0 = free). */
    amountDue: number;
    appliedPromoCode?: string;
    paymentStatus: EventPaymentStatus;
    /** Present only on the detail endpoint — a fresh signed URL to view the uploaded receipt. */
    receiptUrl?: string | null;
    status: EventRegistrationStatus;
    adminNote?: string;
    deleted?: boolean;
    deleted_at?: string;
    created_at: string;
    updated_at: string;
}
